import axios from '@/lib/axios';

type FindStartMonth = {
  custCode: string;
}

const findStartMonth = (data: FindStartMonth) => {
  return axios.post('/facility/orders/set_start_month', data);
}

export default findStartMonth;